import type { Proposta } from '@/types'

export function isRenegotiationProposalStage(etapa?: string | null): boolean {
  return etapa === 'renegociacao' || etapa === 'ajustar_proposta'
}

export function findSentProposals(proposals: Proposta[]): Proposta[] {
  return proposals.filter((p) => p.status === 'enviada' || p.status === 'aceita')
}

export function findRenegotiationDraft(proposals: Proposta[]): Proposta | undefined {
  return proposals.find((p) => p.status === 'rascunho')
}

/** Em renegociação o seletor de plano aparece no rascunho aberto, nunca na proposta enviada. */
export function showProposalPlanSelector(
  formCanEdit: boolean,
  renegotiationWithSentHistory: boolean,
  formOpen: boolean,
): boolean {
  if (!formCanEdit) return false
  if (renegotiationWithSentHistory) return formOpen
  return true
}

export function needsRenegotiationDraft(proposals: Proposta[], etapa?: string | null): boolean {
  if (!isRenegotiationProposalStage(etapa)) return false
  if (findRenegotiationDraft(proposals)) return false
  return findSentProposals(proposals).length > 0
}
